import {Button, Card, Icon, Layout, Modal} from '@ui-kitten/components';
import React from 'react';
import {Alert, PermissionsAndroid, Platform, StyleSheet} from 'react-native';
import {launchCamera, launchImageLibrary} from 'react-native-image-picker';
import {px, wp} from '../../utils';
import {TitleRow} from './index';

const fileIcon = (props) => <Icon {...props} name="file-outline" />;
const cameraIcon = (props) => <Icon {...props} name="camera-outline" />;

const SelectImageModal = ({visible, onClose, setImageData}) => {
  const requestExternalWritePermission = async () => {
    if (Platform.OS === 'android') {
      try {
        const granted = await PermissionsAndroid.request(
          PermissionsAndroid.PERMISSIONS.WRITE_EXTERNAL_STORAGE,
          {
            title: 'External Storage Write Permission',
            message: 'App needs write permission',
          },
        );
        console.log(
          '🚀 ~ file: ImagePicker.jsx ~ line 59 ~ requestExternalWritePermission ~ granted',
          granted,
        );
        // If WRITE_EXTERNAL_STORAGE Permission is granted
        return granted === PermissionsAndroid.RESULTS.GRANTED;
      } catch (err) {
        console.log(
          '🚀 ~ file: ImagePicker.jsx ~ line 93 ~ requestExternalWritePermission ~ err',
          err,
        );
        Alert.alert('Error', 'Write permission err', err);
        return false;
      }
    }
    return true;
  };

  const captureImage = async () => {
    const options = {
      mediaType: 'photo',
      maxWidth: 300,
      maxHeight: 550,
      quality: 1,
      saveToPhotos: true,
      includeBase64: true,
    };
    const isStoragePermitted = await requestExternalWritePermission();

    if (isStoragePermitted) {
      launchCamera(options, (response) => {
        if (response.didCancel) {
          return;
        } else if (response.errorCode === 'camera_unavailable') {
          Alert.alert('Error', 'Camera not available on device');
          return;
        } else if (response.errorCode === 'permission') {
          Alert.alert('Error', 'Permission not satisfied');
          return;
        } else if (response.errorCode === 'others') {
          Alert.alert('Error', response.errorMessage);
          return;
        }
        setImageData(response);
      });
    }
  };

  const chooseFile = () => {
    const options = {
      mediaType: 'photo',
      maxWidth: 300,
      maxHeight: 550,
      quality: 1,
    };
    launchImageLibrary(options, (response) => {
      if (response.didCancel) {
        return;
      } else if (response.errorCode === 'camera_unavailable') {
        Alert.alert('Error', 'Camera not available on device');
        return;
      } else if (response.errorCode === 'permission') {
        Alert.alert('Error', 'Permission not satisfied');
        return;
      } else if (response.errorCode === 'others') {
        Alert.alert('Error', response.errorMessage);
        return;
      }
      setImageData(response);
    });
  };

  return (
    <Modal
      visible={visible}
      backdropStyle={styles.backdrop}
      onBackdropPress={onClose}>
      <Card disabled={true}>
        <Layout style={styles.container}>
          <TitleRow
            title="Select image"
            type="primary"
            iconName="close-circle-outline"
            onIconClick={onClose}
            containerStyle={styles.title}
          />
          <Layout style={styles.body}>
            <Button
              style={styles.marginTop}
              status="basic"
              size="large"
              accessoryLeft={cameraIcon}
              onPress={() => {
                captureImage();
                onClose();
              }}>
              {'Take photo'}
            </Button>
            <Button
              style={styles.marginTop}
              status="basic"
              size="large"
              accessoryLeft={fileIcon}
              onPress={() => {
                chooseFile();
                onClose();
              }}>
              {'Choose from gallery'}
            </Button>
          </Layout>
        </Layout>
      </Card>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    height: px(290),
    width: wp(90),
  },
  backdrop: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
  },
  title: {
    width: '100%',
  },
  marginTop: {
    marginTop: px(30),
  },
  body: {
    marginHorizontal: px(17),
  },
});

export default SelectImageModal;
